import './App.css';
import EmailPasswordAuth from './Components/Email-Password-Auth/EmailPasswordAuth';
import PopUpGoogle from './Components/PopUpGoogle/PopUpGoogle.js';


function App() {
  return (
    <div className="App">
      
      <EmailPasswordAuth></EmailPasswordAuth>
      <PopUpGoogle></PopUpGoogle>
    </div>
  );
}

export default App;
